import i18n from '../i18n/config';

/**
 * Get the current locale code for formatting dates and numbers
 * @returns 'nb-NO' for Norwegian or 'en-US' for English
 */
export const getCurrentLocale = (): string => {
  return i18n.language === 'en' ? 'en-US' : 'nb-NO';
};

/**
 * Format a date using the current locale
 * @param date - The date to format
 * @param options - Intl.DateTimeFormatOptions
 * @returns Formatted date string
 */
export const formatDateLocalized = (
  date: Date | string | number,
  options?: Intl.DateTimeFormatOptions
): string => {
  const dateObj = typeof date === 'string' || typeof date === 'number' ? new Date(date) : date;
  return dateObj.toLocaleDateString(getCurrentLocale(), options);
};

/**
 * Format a number using the current locale
 * @param value - The number to format
 * @param options - Intl.NumberFormatOptions
 * @returns Formatted number string
 */
export const formatNumberLocalized = (
  value: number,
  options?: Intl.NumberFormatOptions
): string => {
  return value.toLocaleString(getCurrentLocale(), options);
};

/**
 * Format a date and time using the current locale
 * @param date - The date to format
 * @param options - Intl.DateTimeFormatOptions
 * @returns Formatted date and time string
 */
export const formatDateTimeLocalized = (
  date: Date | string | number,
  options?: Intl.DateTimeFormatOptions
): string => {
  const dateObj = typeof date === 'string' || typeof date === 'number' ? new Date(date) : date;
  return dateObj.toLocaleString(getCurrentLocale(), options);
};

/**
 * Format a time using the current locale
 * @param date - The date to format
 * @param options - Intl.DateTimeFormatOptions
 * @returns Formatted time string
 */
export const formatTimeLocalized = (
  date: Date | string | number,
  options?: Intl.DateTimeFormatOptions
): string => {
  const dateObj = typeof date === 'string' || typeof date === 'number' ? new Date(date) : date;
  return dateObj.toLocaleTimeString(getCurrentLocale(), options);
};
